module.exports = __webpack_public_path__ + "img/2025-0212-0201.3dbf09ec.png";